module.exports = __webpack_public_path__ + "static/media/forest_song.b9d25b9b.mp3";